import View from './view.js';
import React from 'react';
import useInputPhone from '../useInputPhone.js';

export default function Logic(props) {
  let input = useInputPhone(props);
  return <View {...props} {...input} />;
}